module.exports = __webpack_public_path__ + "img/background_text-05.5f55d2e5.png";